export const getBuilderWidgetClass = (builderWidgetId: string) => {
	return `w-${builderWidgetId}`
}

export const getWrapperSelectorForWidget = (builderWidgetId: string) => {
	return `.${getBuilderWidgetClass(builderWidgetId)}`
}

export const getPresetsInstanceWrapperClass = (instanceKey: string, supportExternalDependenciesCss: boolean) => {
	return supportExternalDependenciesCss ? `${instanceKey}-presets-wrapper` : `c-${instanceKey}`
}

export const getPresetsInstanceWrapperSelector = (instanceKey: string, supportExternalDependenciesCss: boolean) => {
	return `.${getPresetsInstanceWrapperClass(instanceKey, supportExternalDependenciesCss)}`
}
